// extracted by mini-css-extract-plugin
export default {"CitiesList":"CitiesList_CitiesList__Wo60w"};